import Vue from 'vue';
import VueMq from 'vue-mq';
import BootstrapVue from 'bootstrap-vue';
import vSelect from 'vue-select';
import Router from 'vue-router';
import VueScrollTo from 'vue-scrollto';
import './class-component-hooks';
import store from './store';
import './filters';
import Slideshow from './components/slideshow/Slideshow.vue';
import SlideshowItem from './components/slideshow/SlideshowItem.vue';
import PartTeaser from './components/part-teaser/PartTeaser.vue';
import QuickSearch from './components/quick-search/QuickSearch.vue';
import QuickSearchResult from './components/quick-search/QuickSearchResult.vue';
import VinSearchResult from './components/vin-search/VinSearchResult.vue';
import RelatedPartsContainer from './components/part-details/RelatedPartsContainer.vue';
import PartDetailsActions from './components/part-details/PartDetailsActions.vue';
import ShoppingCartActions from './components/shopping-cart/ShoppingCartActions.vue';
import ShoppingCartOverview from './components/shopping-cart/ShoppingCartOverview.vue';
import ShoppingCartUpload from './components/shopping-cart/upload/ShoppingCartUpload.vue';
import ShoppingCartMenu from './components/shopping-cart/menu/ShoppingCartMenu.vue';
import ShoppingCartItemActions from './components/shopping-cart/ShoppingCartItemActions.vue';
import Navigation from './components/navigation/Navigation.vue';
import AvailabilityClock from './components/availability-clock/AvailabilityClock.vue';
import NavigationItem from './components/navigation/NavigationItem.vue';
import CountryStateSelect from './components/country-state-select/CountryStateSelect.vue';
import ShoppingCartItemUserInfoText from './components/shopping-cart/ShoppingCartItemUserInfoText.vue';
import DynamicVisibilityContainer from './components/dynamic-visibility-container/DynamicVisibilityContainer.vue';
import DynamicVisibilityForValuesContainer from './components/dynamic-visibility-container/DynamicVisibilityForValuesContainer.vue';
import OrderList from './components/orders/OrderList.vue';
import PartSearch from './components/part-search/PartSearch.vue';
import CatalogueSearch from './components/catalogue-search/CatalogueSearch.vue';
import CookieDisclaimer from './components/cookie-disclaimer/CookieDisclaimer.vue';
import DepositPartInfoToolTip from './components/deposit-part-info-tooltip/DepositPartInfoToolTip.vue';
import { ShoppingCartModuleTypes } from './store/modules/shopping-cart';
import { MoreIcon } from '@/components/icons/MoreIcon';
import { LessIcon } from '@/components/icons/LessIcon';
import Breadcrumb from './components/breadcrumb/Breadcrumb.vue';
import GoogleMarkupData from './components/breadcrumb/GoogleMarkupData.vue';
import RandomPartsList from './components/car/RandomPartsList.vue';
import AvailablePartsList from './components/car/AvailablePartsList.vue';
import BrandPartsSearchBox from './components/brand-landing-page/BrandPartsSearchBox.vue';
import PartCatalogueAssembly from './components/part-catalogue/PartCatalogueAssembly.vue';
import PartCatalogueLandingPage from './components/part-catalogue/PartCatalogueLandingPage.vue';
import CurrencySelectBox from './components/multi-currency/CurrencySelectBox.vue';

// activate devtools support if dev mode is active
Vue.config.devtools = process.env.VUE_APP_MODE === 'dev';

// Setup vue-mq which enables easy detection of breakpoints by using the css variables defined by bootstrap
Vue.use(VueMq, {
    breakpoints: {
        xs: parseInt(
            getComputedStyle(document.body)
                .getPropertyValue('--breakpoint-sm')
                .replace('px', ''),
            10
        ),
        sm: parseInt(
            getComputedStyle(document.body)
                .getPropertyValue('--breakpoint-md')
                .replace('px', ''),
            10
        ),
        md: parseInt(
            getComputedStyle(document.body)
                .getPropertyValue('--breakpoint-lg')
                .replace('px', ''),
            10
        ),
        lg: parseInt(
            getComputedStyle(document.body)
                .getPropertyValue('--breakpoint-xl')
                .replace('px', ''),
            10
        ),
        xl: Infinity,
    },
});

// Programmatic Scrolling
Vue.use(VueScrollTo);

// Bootstrap components for vue
Vue.use(BootstrapVue);

// select for vue
Vue.component('v-select', vSelect);

Vue.config.productionTip = false;

mountIfDOMElementExists(
    '#header',
    () =>
        new Vue({
            template: '#header-template',
            store,
            components: {
                Navigation,
                NavigationItem,
                QuickSearch,
                ShoppingCartMenu,
                AvailabilityClock,
                CurrencySelectBox,
            },
        })
);

mountIfDOMElementExists(
    '#slideshow',
    () =>
        new Vue({
            template: '#slideshow-template',
            components: {
                Slideshow,
                SlideshowItem,
            },
        })
);

mountIfDOMElementExists(
    '#vin-search-result',
    () =>
        new Vue({
            store,
            template: '#vin-search-result-template',
            components: {
                VinSearchResult,
            },
        })
);

mountIfDOMElementExists(
    '#quick-search-result',
    () =>
        new Vue({
            store,
            template: '#quick-search-result-template',
            components: {
                QuickSearchResult,
                ShoppingCartActions,
            },
        })
);

mountIfDOMElementExists(
    '#teaser-container',
    () =>
        new Vue({
            store,
            template: '#teaser-container-template',
            components: {
                PartTeaser,
                ShoppingCartActions,
            },
        })
);

mountIfDOMElementExists(
    '#content-section-container',
    () =>
        new Vue({
            store,
            template: '#content-section-container-template',
            components: {
                PartTeaser,
                ShoppingCartActions,
            },
        })
);

mountIfDOMElementExists(
    '#related-parts-container',
    () =>
        new Vue({
            store,
            template: '#related-parts-container-template',
            components: {
                RelatedPartsContainer,
            },
        })
);

mountIfDOMElementExists(
    '#part-details-actions',
    () =>
        new Vue({
            store,
            template: '#part-details-actions-template',
            components: {
                PartDetailsActions,
            },
        })
);

mountIfDOMElementExists(
    '#register-form',
    () =>
        new Vue({
            template: '#register-form-template',
            store,
            components: {
                CountryStateSelect,
                DynamicVisibilityForValuesContainer,
            },
        })
);

mountIfDOMElementExists(
    '#address-settings-form',
    () =>
        new Vue({
            template: '#address-settings-form-template',
            store,
            components: {
                CountryStateSelect,
                DynamicVisibilityContainer,
            },
        })
);

mountIfDOMElementExists(
    '#password-settings-form',
    () =>
        new Vue({
            template: '#password-settings-form-template',
            store,
        })
);

mountIfDOMElementExists(
    '#shopping-cart-overview',
    () =>
        new Vue({
            store,
            template: '#shopping-cart-overview-template',
            components: {
                ShoppingCartOverview,
                ShoppingCartItemActions,
                ShoppingCartItemUserInfoText,
            },
        })
);

mountIfDOMElementExists(
    '#order-personal-data-form',
    () =>
        new Vue({
            store,
            template: '#order-personal-data-form-template',
            components: {
                DynamicVisibilityForValuesContainer,
                DynamicVisibilityContainer,
                CountryStateSelect,
            },
        })
);

mountIfDOMElementExists(
    '#orders-list',
    () =>
        new Vue({
            store,
            template: '#orders-list-template',
            components: {
                OrderList,
            },
        })
);

mountIfDOMElementExists(
    '#cookie-disclaimer',
    () =>
        new Vue({
            template: '#cookie-disclaimer-template',
            components: {
                CookieDisclaimer,
            },
        })
);

mountIfDOMElementExists(
    '#part-catalogue-search',
    () =>
        new Vue({
            template: '#part-catalogue-search-template',
            store,
            components: {
                CatalogueSearch,
            },
        })
);

mountIfDOMElementExists(
    '#part-search',
    () =>
        new Vue({
            template: '#part-search-template',
            store,
            components: {
                PartSearch,
            },
        })
);

mountIfDOMElementExists(
    '#part-categories-overview',
    () =>
        new Vue({
            template: '#part-categories-overview-template',
            store,
            components: {
                MoreIcon,
                LessIcon,
            },
        })
);

mountIfDOMElementExists(
    '#shopping-cart-upload',
    () =>
        new Vue({
            template: '#shopping-cart-upload-template',
            store,
            components: {
                ShoppingCartUpload,
            },
        })
);

mountIfDOMElementExists(
    '#deposit-part-info-tooltip',
    () =>
        new Vue({
            template: '#deposit-part-info-tooltip-template',
            store,
            components: {
                DepositPartInfoToolTip,
            },
        })
);

mountIfDOMElementExists(
    '#breadcrumb',
    () =>
        new Vue({
            store,
            template: '#breadcrumb-template',
            components: {
                Breadcrumb,
            },
        })
);

mountIfDOMElementExists(
    '#google-breadcrumb-markup-data',
    () =>
        new Vue({
            store,
            template: '#google-breadcrumb-markup-data-template',
            components: {
                GoogleMarkupData,
            },
        })
);

mountIfDOMElementExists(
    '#random-parts-list',
    () =>
        new Vue({
            template: '#random-parts-list-template',
            store,
            components: {
                RandomPartsList,
            },
        })
);

mountIfDOMElementExists(
    '#available-parts-list',
    () =>
        new Vue({
            template: '#available-parts-list-template',
            store,
            components: {
                AvailablePartsList,
            },
        })
);

mountIfDOMElementExists(
    '#brand-parts-search-box',
    () =>
        new Vue({
            template: '#brand-parts-search-box-template',
            store,
            components: {
                BrandPartsSearchBox,
            },
        })
);

mountIfDOMElementExists(
    '#part-catalogue-assembly',
    () =>
        new Vue({
            template: '#part-catalogue-assembly-template',
            store,
            components: {
                PartCatalogueAssembly,
            },
        })
);

mountIfDOMElementExists(
    '#part-catalogue-landing-page',
    () =>
        new Vue({
            template: '#part-catalogue-landing-page-template',
            store,
            components: {
                PartCatalogueLandingPage,
            },
        })
);

store.dispatch(ShoppingCartModuleTypes.actions.loadShoppingCarts);

/**
 * Create a Vue instance with the given function if an element with the given id exists in the DOM.
 * @param id of the DOM element in the format: #element-id
 * @param createInstance function that is used to create the instance that should be mounted
 */
function mountIfDOMElementExists(id: string, createInstance: () => Vue): void {
    if (window.document.querySelector(id)) {
        createInstance().$mount(id);
    }
}
